import React from 'react';
import { useParams } from 'react-router';
import useMasterMedicine from '../../../apis/master-medicines/hooks/useMasterMedicine';
import { Loading } from '../../../healtheraComponents';
import MasterMedicine from '../components/MasterMedicine';
import { useVirtualMedicines } from '../../../apis/virtual-medicines/hooks/useVirtualMedicines';

interface Params {
  masterMedicineId: string;
}

const MasterMedicineContainer = () => {
  const { masterMedicineId } = useParams<Params>();

  const { masterMedicine, isLoading: isLoadingMasterMedicine } = useMasterMedicine(masterMedicineId);
  const { virtualMedicines, isLoading: isLoadingMedicines } = useVirtualMedicines(masterMedicineId);

  const isLoading = isLoadingMasterMedicine || isLoadingMedicines;

  if (isLoading) {
    return <Loading />;
  }

  if (masterMedicineId !== 'create' && !masterMedicine) {
    return <div>Master medicine not found</div>;
  }

  return <MasterMedicine medicines={virtualMedicines} masterMedicine={masterMedicine} />;
};

export default MasterMedicineContainer;
